// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%236b7280%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-invoices-container {
  padding: 1.5rem;
  background: #f9fafb;
  min-height: calc(100vh - 118px);
  margin-top: 20px;
}
.system-invoices-container .system-invoices-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e5e7eb;
}
.system-invoices-container .system-invoices-header .header-left h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #111827;
  font-weight: 600;
}
.system-invoices-container .system-invoices-header .header-left .company-name {
  margin: 0.25rem 0 0 0;
  font-size: 0.95rem;
  color: #6b7280;
}
.system-invoices-container .system-invoices-header .header-buttons {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper {
  position: relative;
  z-index: 10;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-toggle-btn svg {
  font-size: 0.875rem;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  padding: 1rem;
  width: 350px;
  max-height: 320px;
  overflow-y: auto;
  z-index: 1000;
  animation: slideDown 0.2s ease;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group:last-of-type {
  margin-bottom: 1rem;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group input,
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  color: #111827;
  transition: border-color 0.2s;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group input:focus,
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group input::placeholder,
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group select::placeholder {
  color: #9ca3af;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group select {
  cursor: pointer;
  background-color: white;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 1.25rem;
  padding-right: 2.5rem;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group input[type=number]::-webkit-inner-spin-button, .system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-group input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-actions {
  position: sticky;
  bottom: -9px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-top: 1px solid #ddd;
  background-color: white;
  z-index: 1001;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-actions .clear-btn,
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-actions .hide-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-actions .clear-btn {
  background-color: #dc3545;
  color: white;
}
.system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box .filter-actions .hide-btn {
  background-color: #6c757d;
  color: white;
}
.system-invoices-container .system-invoices-header .header-buttons .create-invoice-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.system-invoices-container .system-invoices-header .header-buttons .create-invoice-btn svg {
  font-size: 0.875rem;
}
.system-invoices-container .invoices-table-wrapper {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.system-invoices-container .invoices-table-wrapper .no-data-message {
  text-align: center;
  padding: 3rem 1rem;
}
.system-invoices-container .invoices-table-wrapper .no-data-message p {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}
.system-invoices-container .invoices-table-wrapper .no-data-message .create-first-btn {
  padding: 0.625rem 1.25rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}
.system-invoices-container .invoices-table-wrapper .no-data-message .create-first-btn:hover {
  background-color: #2563eb;
}
.system-invoices-container .invoices-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.system-invoices-container .invoices-table thead {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.system-invoices-container .invoices-table thead tr th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  white-space: nowrap;
}
.system-invoices-container .invoices-table tbody tr {
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s;
}
.system-invoices-container .invoices-table tbody tr:hover {
  background-color: #f9fafb;
}
.system-invoices-container .invoices-table tbody tr:last-child {
  border-bottom: none;
}
.system-invoices-container .invoices-table tbody tr td {
  padding: 1rem;
  color: #374151;
  vertical-align: top;
}
.system-invoices-container .invoices-table tbody tr td.invoice-number {
  font-weight: 500;
  color: #3b82f6;
}
.system-invoices-container .invoices-table tbody tr td.amount {
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
}
.system-invoices-container .invoices-table tbody tr td.amount.paid {
  color: #10b981;
}
.system-invoices-container .invoices-table tbody tr td.amount.pending {
  color: #ef4444;
}
.system-invoices-container .invoices-table tbody tr td .items-cell {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.system-invoices-container .invoices-table tbody tr td .items-cell .item-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.system-invoices-container .invoices-table tbody tr td .items-cell .item-row .item-name {
  font-weight: 500;
  color: #111827;
}
.system-invoices-container .invoices-table tbody tr td .items-cell .item-row .item-desc {
  font-size: 0.8rem;
  color: #6b7280;
}
.system-invoices-container .invoices-table tbody tr td .status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
}
.system-invoices-container .invoices-table tbody tr td .status-badge.status-paid {
  background-color: #d1fae5;
  color: #065f46;
}
.system-invoices-container .invoices-table tbody tr td .status-badge.status-pending {
  background-color: #fef3c7;
  color: #92400e;
}
.system-invoices-container .invoices-table tbody tr td .status-badge.status-part-payment {
  background-color: #dbeafe;
  color: #1e40af;
  white-space: nowrap;
}
.system-invoices-container .invoices-table tbody tr td .status-badge.status-cancelled {
  background-color: #fee2e2;
  color: #991b1b;
}
.system-invoices-container .invoices-table tbody tr td .status-badge.status-overdue {
  background-color: #fecaca;
  color: #7f1d1d;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn {
  flex: 1 1;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.preview-btn {
  background-color: #6c757d;
  color: white;
  padding: 0.5rem 0.75rem;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.preview-btn:hover {
  background: #53595e;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.preview-btn svg {
  font-size: 1rem;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.download-btn {
  background-color: #218338;
  color: white;
  padding: 0.5rem 0.75rem;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.download-btn:hover {
  background: #4cae4c;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.download-btn svg {
  font-size: 1rem;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.update-status-btn {
  background-color: #17a2b8;
  color: white;
  white-space: nowrap;
}
.system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn.update-status-btn:hover {
  background: #138496;
}
@media (max-width: 768px) {
  .system-invoices-container {
    padding: 1rem;
  }
  .system-invoices-container .system-invoices-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .system-invoices-container .system-invoices-header .header-buttons {
    width: 100%;
    flex-direction: column;
  }
  .system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper {
    width: 100%;
  }
  .system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-toggle-btn {
    width: 100%;
    justify-content: center;
  }
  .system-invoices-container .system-invoices-header .header-buttons .filter-dropdown-wrapper .filter-dropdown-box {
    left: 10px !important;
    right: 10px;
    min-width: auto;
    max-width: none;
  }
  .system-invoices-container .system-invoices-header .header-buttons .create-invoice-btn {
    width: 100%;
    justify-content: center;
  }
  .system-invoices-container .invoices-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .system-invoices-container .invoices-table thead,
  .system-invoices-container .invoices-table tbody,
  .system-invoices-container .invoices-table tr,
  .system-invoices-container .invoices-table td,
  .system-invoices-container .invoices-table th {
    display: block;
  }
  .system-invoices-container .invoices-table thead {
    display: none;
  }
  .system-invoices-container .invoices-table tbody tr {
    margin-bottom: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 1rem;
  }
  .system-invoices-container .invoices-table tbody tr td {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #f3f4f6;
  }
  .system-invoices-container .invoices-table tbody tr td:last-child {
    border-bottom: none;
  }
  .system-invoices-container .invoices-table tbody tr td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #6b7280;
    flex-shrink: 0;
    width: 120px;
  }
  .system-invoices-container .invoices-table tbody tr td.actions-cell {
    justify-content: center;
    flex-direction: column;
    gap: 0.5rem;
  }
  .system-invoices-container .invoices-table tbody tr td.actions-cell .action-btn {
    width: 100%;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SystemInvoices/SystemInvoices.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gCAAA;AAAJ;AAGM;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AADR;AAIM;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;AAFR;AAMI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AAJN;AAMM;EACE,kBAAA;EACA,WAAA;AAJR;AAMQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAJV;AAMU;EACE,mBAAA;AAJZ;AAQQ;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,2CAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AANV;AAWY;EACE,mBAAA;AATd;AAYY;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAVd;AAaY;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,6BAAA;AAXd;AAac;;EACE,aAAA;EACA,kCAAA;EACA,6CAAA;AAVhB;AAac;;EACE,cAAA;AAVhB;AAcY;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,wCAAA;EACA,wBAAA;EACA,qBAAA;AAZd;AAgBc;EAEE,wBAAA;EACA,SAAA;AAfhB;AAWY;EAME,qBAAA;EACA,0BAAA;AAdd;AAuDU;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,aAAA;AArDZ;AAuDY;;EAEE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AArDd;AAwDY;EACE,yBAAA;EACA,YAAA;AAtDd;AAyDY;EACE,yBAAA;EACA,YAAA;AAvDd;AA6DM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AA3DR;AA6DQ;EACE,mBAAA;AA3DV;AAiEE;EACE,iBAAA;EACA,qBAAA;EACA,wCAAA;EACA,gBAAA;AA/DJ;AAiEI;EACE,kBAAA;EACA,kBAAA;AA/DN;AAiEM;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AA/DR;AAkEM;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;AAhER;AAkEQ;EACE,yBAAA;AAhEV;AAsEE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AApEJ;AAsEI;EACE,yBAAA;EACA,gCAAA;AApEN;AAuEQ;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AArEV;AA2EM;EACE,gCAAA;EACA,iCAAA;AAzER;AA2EQ;EACE,yBAAA;AAzEV;AA4EQ;EACE,mBAAA;AA1EV;AA6EQ;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AA3EV;AA6EU;EACE,gBAAA;EACA,cAAA;AA3EZ;AA8EU;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AA5EZ;AA8EY;EACE,cAAA;AA5Ed;AA+EY;EACE,cAAA;AA7Ed;AAiFU;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA/EZ;AAiFY;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA/Ed;AAiFc;EACE,gBAAA;EACA,cAAA;AA/EhB;AAkFc;EACE,iBAAA;EACA,cAAA;AAhFhB;AAqFU;EACE,qBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AAnFZ;AAqFY;EACE,yBAAA;EACA,cAAA;AAnFd;AAsFY;EACE,yBAAA;EACA,cAAA;AApFd;AAuFY;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AArFd;AAwFY;EACE,yBAAA;EACA,cAAA;AAtFd;AAyFY;EACE,yBAAA;EACA,cAAA;AAvFd;AA2FU;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAzFZ;AA2FY;EACE,SAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAzFd;AA2Fc;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;AAzFhB;AA2FgB;EACE,mBAAA;AAzFlB;AA4FgB;EACE,eAAA;AA1FlB;AA8Fc;EACE,yBAAA;EACA,YAAA;EACA,uBAAA;AA5FhB;AA8FgB;EACE,mBAAA;AA5FlB;AA+FgB;EACE,eAAA;AA7FlB;AAiGc;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;AA/FhB;AAiGgB;EACE,mBAAA;AA/FlB;AAyGE;EA7aF;IA8aI,aAAA;EAtGF;EAwGE;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAtGJ;EAwGI;IACE,WAAA;IACA,sBAAA;EAtGN;EAwGM;IACE,WAAA;EAtGR;EAwGQ;IACE,WAAA;IACA,uBAAA;EAtGV;EAyGQ;IACE,qBAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EAvGV;EA2GM;IACE,WAAA;IACA,uBAAA;EAzGR;EA8GE;IACE,cAAA;IACA,gBAAA;IACA,mBAAA;EA5GJ;EA8GI;;;;;IAKE,cAAA;EA5GN;EA+GI;IACE,aAAA;EA7GN;EAiHM;IACE,mBAAA;IACA,yBAAA;IACA,qBAAA;IACA,aAAA;EA/GR;EAiHQ;IACE,aAAA;IACA,8BAAA;IACA,iBAAA;IACA,gCAAA;EA/GV;EAiHU;IACE,mBAAA;EA/GZ;EAkHU;IACE,yBAAA;IACA,gBAAA;IACA,cAAA;IACA,cAAA;IACA,YAAA;EAhHZ;EAmHU;IACE,uBAAA;IACA,sBAAA;IACA,WAAA;EAjHZ;EAmHY;IACE,WAAA;EAjHd;AACF;;AA2HA;EACE;IACE,UAAA;IACA,4BAAA;EAxHF;EA0HA;IACE,UAAA;IACA,wBAAA;EAxHF;AACF","sourcesContent":["// System Invoices Styles\n.system-invoices-container {\n  padding: 1.5rem;\n  background: #f9fafb;\n  min-height: calc(100vh - 118px);\n  margin-top: 20px;\n\n  .system-invoices-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    padding-bottom: 1rem;\n    border-bottom: 2px solid #e5e7eb;\n\n    .header-left {\n      h2 {\n        margin: 0;\n        font-size: 1.5rem;\n        color: #111827;\n        font-weight: 600;\n      }\n\n      .company-name {\n        margin: 0.25rem 0 0 0;\n        font-size: 0.95rem;\n        color: #6b7280;\n      }\n    }\n\n    .header-buttons {\n      display: flex;\n      gap: 0.75rem;\n      align-items: center;\n\n      .filter-dropdown-wrapper {\n        position: relative;\n        z-index: 10;\n\n        .filter-toggle-btn {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          padding: 0.625rem 1.25rem;\n          background-color: var(--primary-color);\n          color: white;\n          border: none;\n          border-radius: 0.375rem;\n          font-size: 0.875rem;\n          font-weight: 500;\n          cursor: pointer;\n          transition: background-color 0.2s;\n\n          svg {\n            font-size: 0.875rem;\n          }\n        }\n\n        .filter-dropdown-box {\n          position: absolute;\n          top: calc(100% + 5px);\n          right: 0;\n          background: white;\n          border: 1px solid #e5e7eb;\n          border-radius: 0.5rem;\n          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n          padding: 1rem;\n          width: 350px;\n          max-height: 320px;\n          overflow-y: auto;\n          z-index: 1000;\n          animation: slideDown 0.2s ease;\n\n          .filter-group {\n            // margin-bottom: 1rem;\n\n            &:last-of-type {\n              margin-bottom: 1rem;\n            }\n\n            label {\n              display: block;\n              margin-bottom: 0.5rem;\n              font-size: 0.875rem;\n              font-weight: 500;\n              color: #374151;\n            }\n\n            input,\n            select {\n              width: 100%;\n              padding: 0.5rem;\n              border: 1px solid #d1d5db;\n              border-radius: 0.375rem;\n              font-size: 0.875rem;\n              color: #111827;\n              transition: border-color 0.2s;\n\n              &:focus {\n                outline: none;\n                border-color: var(--primary-color);\n                box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n              }\n\n              &::placeholder {\n                color: #9ca3af;\n              }\n            }\n\n            select {\n              cursor: pointer;\n              background-color: white;\n              appearance: none;\n              background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%236b7280'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\n              background-repeat: no-repeat;\n              background-position: right 0.5rem center;\n              background-size: 1.25rem;\n              padding-right: 2.5rem;\n            }\n\n            input[type=\"number\"] {\n              &::-webkit-inner-spin-button,\n              &::-webkit-outer-spin-button {\n                -webkit-appearance: none;\n                margin: 0;\n              }\n              appearance: textfield;\n              -moz-appearance: textfield;\n            }\n          }\n\n          // .filter-actions {\n          //   display: flex;\n          //   gap: 0.5rem;\n          //   margin-top: 1rem;\n          //   padding-top: 1rem;\n          //   border-top: 1px solid #e5e7eb;\n\n          //   button {\n          //     flex: 1;\n          //     padding: 0.5rem 1rem;\n          //     border: none;\n          //     border-radius: 0.375rem;\n          //     font-size: 0.875rem;\n          //     font-weight: 500;\n          //     cursor: pointer;\n          //     transition: all 0.2s ease;\n\n          //     &.clear-btn {\n          //       background-color: #f3f4f6;\n          //       color: #374151;\n\n          //       &:hover {\n          //         background-color: #e5e7eb;\n          //       }\n          //     }\n\n          //     &.hide-btn {\n          //       background-color: var(--primary-color);\n          //       color: white;\n\n          //       &:hover {\n          //         opacity: 0.9;\n          //       }\n          //     }\n          //   }\n          // }\n\n          .filter-actions {\n            position: sticky;\n            bottom: -9px;\n            display: flex;\n            justify-content: space-between;\n            padding: 10px;\n            border-top: 1px solid #ddd;\n            background-color: white;\n            z-index: 1001;\n\n            .clear-btn,\n            .hide-btn {\n              padding: 6px 12px;\n              border: none;\n              border-radius: 6px;\n              font-weight: 500;\n              font-size: 13px;\n              cursor: pointer;\n            }\n\n            .clear-btn {\n              background-color: #dc3545;\n              color: white;\n            }\n\n            .hide-btn {\n              background-color: #6c757d;\n              color: white;\n            }\n          }\n        }\n      }\n\n      .create-invoice-btn {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.625rem 1.25rem;\n        background-color: var(--primary-color);\n        color: white;\n        border: none;\n        border-radius: 0.375rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background-color 0.2s;\n\n        svg {\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n\n  .invoices-table-wrapper {\n    background: white;\n    border-radius: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n\n    .no-data-message {\n      text-align: center;\n      padding: 3rem 1rem;\n\n      p {\n        font-size: 1rem;\n        color: #6b7280;\n        margin-bottom: 1.5rem;\n      }\n\n      .create-first-btn {\n        padding: 0.625rem 1.25rem;\n        background-color: #3b82f6;\n        color: white;\n        border: none;\n        border-radius: 0.375rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: #2563eb;\n        }\n      }\n    }\n  }\n\n  .invoices-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.875rem;\n\n    thead {\n      background-color: #f9fafb;\n      border-bottom: 1px solid #e5e7eb;\n\n      tr {\n        th {\n          padding: 0.75rem 1rem;\n          text-align: left;\n          font-weight: 600;\n          color: #374151;\n          font-size: 0.875rem;\n          white-space: nowrap;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        border-bottom: 1px solid #f3f4f6;\n        transition: background-color 0.2s;\n\n        &:hover {\n          background-color: #f9fafb;\n        }\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        td {\n          padding: 1rem;\n          color: #374151;\n          vertical-align: top;\n\n          &.invoice-number {\n            font-weight: 500;\n            color: #3b82f6;\n          }\n\n          &.amount {\n            font-weight: 500;\n            text-align: left;\n            white-space: nowrap;\n\n            &.paid {\n              color: #10b981;\n            }\n\n            &.pending {\n              color: #ef4444;\n            }\n          }\n\n          .items-cell {\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n\n            .item-row {\n              display: flex;\n              flex-direction: column;\n              gap: 0.25rem;\n\n              .item-name {\n                font-weight: 500;\n                color: #111827;\n              }\n\n              .item-desc {\n                font-size: 0.8rem;\n                color: #6b7280;\n              }\n            }\n          }\n\n          .status-badge {\n            display: inline-block;\n            padding: 0.25rem 0.75rem;\n            border-radius: 9999px;\n            font-size: 0.75rem;\n            font-weight: 500;\n            text-transform: capitalize;\n\n            &.status-paid {\n              background-color: #d1fae5;\n              color: #065f46;\n            }\n\n            &.status-pending {\n              background-color: #fef3c7;\n              color: #92400e;\n            }\n\n            &.status-part-payment {\n              background-color: #dbeafe;\n              color: #1e40af;\n              white-space: nowrap;\n            }\n\n            &.status-cancelled {\n              background-color: #fee2e2;\n              color: #991b1b;\n            }\n\n            &.status-overdue {\n              background-color: #fecaca;\n              color: #7f1d1d;\n            }\n          }\n\n          &.actions-cell {\n            display: flex;\n            gap: 0.5rem;\n            align-items: center;\n\n            .action-btn {\n              flex: 1;\n              padding: 8px 12px;\n              border: none;\n              border-radius: 6px;\n              font-weight: 500;\n              cursor: pointer;\n              transition: all 0.2s ease;\n              font-size: 13px;\n\n              &.preview-btn {\n                background-color: #6c757d;\n                color: white;\n                padding: 0.5rem 0.75rem;\n\n                &:hover {\n                  background: #53595e;\n                }\n\n                svg {\n                  font-size: 1rem;\n                }\n              }\n\n              &.download-btn {\n                background-color: #218338;\n                color: white;\n                padding: 0.5rem 0.75rem;\n\n                &:hover {\n                  background: #4cae4c;\n                }\n\n                svg {\n                  font-size: 1rem;\n                }\n              }\n\n              &.update-status-btn {\n                background-color: #17a2b8;\n                color: white;\n                white-space: nowrap;\n\n                &:hover {\n                  background: #138496;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n\n    .system-invoices-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 1rem;\n\n      .header-buttons {\n        width: 100%;\n        flex-direction: column;\n\n        .filter-dropdown-wrapper {\n          width: 100%;\n\n          .filter-toggle-btn {\n            width: 100%;\n            justify-content: center;\n          }\n\n          .filter-dropdown-box {\n            left: 10px !important;\n            right: 10px;\n            min-width: auto;\n            max-width: none;\n          }\n        }\n\n        .create-invoice-btn {\n          width: 100%;\n          justify-content: center;\n        }\n      }\n    }\n\n    .invoices-table {\n      display: block;\n      overflow-x: auto;\n      white-space: nowrap;\n\n      thead,\n      tbody,\n      tr,\n      td,\n      th {\n        display: block;\n      }\n\n      thead {\n        display: none;\n      }\n\n      tbody {\n        tr {\n          margin-bottom: 1rem;\n          border: 1px solid #e5e7eb;\n          border-radius: 0.5rem;\n          padding: 1rem;\n\n          td {\n            display: flex;\n            justify-content: space-between;\n            padding: 0.5rem 0;\n            border-bottom: 1px solid #f3f4f6;\n\n            &:last-child {\n              border-bottom: none;\n            }\n\n            &::before {\n              content: attr(data-label);\n              font-weight: 600;\n              color: #6b7280;\n              flex-shrink: 0;\n              width: 120px;\n            }\n\n            &.actions-cell {\n              justify-content: center;\n              flex-direction: column;\n              gap: 0.5rem;\n\n              .action-btn {\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Animation for filter dropdown\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
